// Security alert codes sent by the venue machines (deviceLog meta.code), grouped into the dashboard alert types.
// Any code not listed here (new detections) is shown as "Other".
export const ALERT_TYPES = {
    usb: { label: 'Unapproved USB device', short: 'USB' },
    input: { label: 'Input device issue', short: 'Input device' },
    display: { label: 'Display issue', short: 'Display' },
    hardware: { label: 'Hardware changed', short: 'Hardware' },
    other: { label: 'Other security alert', short: 'Other' },
};

const ALERT_TYPE_BY_CODE = {
    'USB_NOT_ALLOWED': 'usb',
    'SEC-INPUT-KBD': 'input',
    'SEC-INPUT-PTR': 'input',
    'SEC-DISPLAY-001': 'display',
    'SEC-DISPLAY-KVM': 'display',
    'SEC-HW-002': 'hardware',
    'SEC-HW-RECONNECT': 'hardware',
    'SEC-HW-PENDING': 'hardware',
    'SEC-SEAT-001': 'hardware',
};

export const getAlertType = (code) => ALERT_TYPE_BY_CODE[code] ?? 'other';

// Latest event of an alert (deviceLog meta.state)
export const ALERT_STATUS = {
    RAISED: { label: 'Open', color: 'error.main' },
    CLEARED: { label: 'Resolved', color: 'success.main' },
};

// [['USB_NOT_ALLOWED', 2], ['SEC-INPUT-PTR', 1], ['USB_NOT_ALLOWED', 1]] -> { usb: 3, input: 1 }
export const countByAlertType = (codeCounts = []) => codeCounts.reduce((counts, [code, count]) => {
    const type = getAlertType(code);
    counts[type] = (counts[type] ?? 0) + count;
    return counts;
}, {});
